import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import BarTableApi from "api/barTableApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { ColorPicker } from "antd";
import DropdownHours from "components/Common/DropdownHours";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_STATUS_POST,
  STATUS_POST_OPTION,
  TABLE_SHARING_OPTION,
  TABLE_TYPE_OPTION,
} from "helpers/constans";
import DropdownOption from "components/Common/DropdownOption";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";

export default function CreateEditBarTable({
  setIsOpen,
  item,
  setItemToEdit,
  loadTableData,
  setLinkImage,
  barID,
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isEdit = item;

  const STATUS_USER_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const TABLE_SHARING_OPTION_LANG =
    TABLE_SHARING_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const TABLE_TYPE_OPTION_LANG =
    TABLE_TYPE_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const handleSubmit = async (values: any) => {
    // console.log(values, typeof values?.color);
    try {
      const data = {
        ...(!isEdit && { bar_id: barID }),
        ...(!isEdit && { code: values?.code }),
        name: values?.name,
        color:
          typeof values?.color == "string"
            ? values?.color
            : values?.color?.toHexString(),
        time_service: values?.time_service,
        position: values?.position,
        capacity: Number(values?.capacity),
        status: Number(values?.status),
        type: Number(values?.type),
        sharing: Number(values?.sharing),
        service_user_id: values?.service_user?.value,
        // //not valid
        qr_code: values?.code,
        reservation_type: 1,
        description: "Default Description",
      };
      console.log(data);
      const response: any = isEdit
        ? await BarTableApi?.updateBarTable(item?.id, data)
        : await BarTableApi?.createBarTable(data);
      if (response?.data) {
        //  dispatch(onGetBarTables(query));
        loadTableData();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({
    code: Yup.string()
      .nullable()
      .required(`${t("This field is required")}`),
    name: Yup.string()
      .nullable()
      .required(`${t("This field is required")}`),
    position: Yup.string().required(`${t("This field is required")}`),
    capacity: Yup.string().required(`${t("This field is required")}`),
    time_service: Yup.string().required(`${t("This field is required")}`),
    // status: Yup.string().required(`${t("This field is required")}`),
    // type: Yup.string().required(`${t("This field is required")}`),
    // sharing: Yup.string().required(`${t("This field is required")}`),
    // service_user: Yup.string().required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      name: "",
      color: "#1677FF",
      position: "",
      capacity: "",
      time_service: "",
      status: "",
      table_type: null,
      table_sharing: null,
      service_user: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (item) {
      formik.setFieldValue("code", item?.code);
      formik.setFieldValue("name", item?.name);
      formik.setFieldValue("color", item?.color);
      formik.setFieldValue("time_service", item?.time_service);
      formik.setFieldValue("position", item?.position);
      formik.setFieldValue("capacity", item?.capacity);
      formik.setFieldValue("status", item?.status);

      formik.setFieldValue("type", item?.type);
      const type = TABLE_TYPE_OPTION.find((i: any) => i?.value == item?.type);
      formik.setFieldValue("table_type", type);

      formik.setFieldValue("sharing", item?.sharing);
      const sharing = TABLE_SHARING_OPTION.find(
        (i: any) => i?.value == item?.sharing
      );
      formik.setFieldValue("table_sharing", sharing);

      const userService = {
        value: item?.service_user_id,
        label: `${item?.u_name} - ${item?.u_email}`,
      };
      formik.setFieldValue("service_user", userService);
    }
  }, [item]);

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {isEdit ? t("Button Update") : t("Button Create")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={100 - (100 / 2) * Number(Object.keys(formik.errors).length)}
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col xxl={6} className="mt-2">
              <label className="form-label">
                {t("Code")} <span className="text-danger"> *</span>
              </label>
              <input
                className="form-control"
                id="code"
                name="code"
                value={formik?.values?.code}
                placeholder={`${t("Enter the code")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("code", event?.target?.value || "")
                }
                disabled={isEdit}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="text-danger mt-2">{formik.errors.name}</div>
              ) : null}
            </Col>

            <Col xxl={6} className="mt-2">
              <label className="form-label">
                {t("Name")} <span className="text-danger"> *</span>
              </label>
              <input
                className="form-control"
                id="name"
                name="name"
                value={formik?.values?.name}
                placeholder={`${t("Enter the name")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("name", event?.target?.value || "")
                }
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="text-danger mt-2">{formik.errors.name}</div>
              ) : null}
            </Col>

            <Col xxl={6} className="mt-2">
              <label className="form-label w-100">
                {`${t("Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => formik.setFieldValue(`color`, value)}
                value={formik.values?.color}
              />{" "}
              {formik.touched.color && formik.errors.color ? (
                <div className="text-danger mt-2">{formik.errors.color}</div>
              ) : null}
            </Col>

            <Col xxl={6} className="mt-2">
              <label className="form-label w-100">
                {`${t("Time Service")}`} <span className="text-danger"> *</span>
              </label>
              <DropdownHours
                name="time_service"
                initialValue={formik?.values?.time_service}
                placeholder={t("Select the time")}
                onChangeSelect={(value: any) => {
                  formik.setFieldValue(`time_service`, value?.value);
                }}
              />{" "}
              {formik.touched.time_service && formik.errors.time_service ? (
                <div className="text-danger mt-2">
                  {formik.errors.time_service}
                </div>
              ) : null}
            </Col>

            <Col xxl={6} className="mt-2">
              <label className="form-label">{`${t("Position")}`}</label>{" "}
              <span className="text-danger"> *</span>
              <input
                className="form-control"
                id="position"
                name="position"
                type="number"
                value={formik?.values?.position}
                placeholder={`${t("Enter the position")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("position", event?.target?.value || "")
                }
              />
              {formik.touched.position && formik.errors.position ? (
                <div className="text-danger mt-2">{formik.errors.position}</div>
              ) : null}
            </Col>

            <Col xxl={6} className="mt-2">
              <label className="form-label">{`${t("Capacity")}`}</label>{" "}
              <span className="text-danger"> *</span>
              <input
                className="form-control"
                id="capacity"
                name="capacity"
                type="number"
                value={formik?.values?.capacity}
                placeholder={`${t("Enter the capacity")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("capacity", event?.target?.value || "")
                }
              />
              {formik.touched.capacity && formik.errors.capacity ? (
                <div className="text-danger mt-2">{formik.errors.capacity}</div>
              ) : null}
            </Col>

            <Col xxl={6}>
              <label className="form-label">
                {t("Status")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownStatusNew
                name="status"
                dataList={STATUS_USER_OPTION_LANG || []}
                placeholder={`${t("Status")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.status}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("status", event?.value);
                }}
                isHasOptionAll={false}
                colors={COLOR_STATUS_POST}
              />

              {formik.touched.status && formik.errors.status ? (
                <div className="text-danger mt-2">{formik.errors.status}</div>
              ) : null}
            </Col>

            <Col xxl={6}>
              <label className="form-label">
                {t("Type")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownOption
                name="type"
                dataList={TABLE_TYPE_OPTION_LANG || []}
                placeholder={`${t("Type")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.table_type}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("type", event?.value);
                }}
                isHasOptionAll={false}
              />

              {formik.touched.table_type && formik.errors.table_type ? (
                <div className="text-danger mt-2">
                  {formik.errors.table_type}
                </div>
              ) : null}
            </Col>

            <Col xxl={6}>
              <label className="form-label">
                {t("Sharing")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownOption
                name="sharing"
                dataList={TABLE_SHARING_OPTION_LANG || []}
                placeholder={`${t("Sharing")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.table_sharing}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("sharing", event?.value);
                }}
                isHasOptionAll={false}
              />

              {formik.touched.table_sharing && formik.errors.table_sharing ? (
                <div className="text-danger mt-2">
                  {formik.errors.table_sharing}
                </div>
              ) : null}
            </Col>

            <Col xxl={6}>
              <label className="form-label">
                {t("Service User")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownAsyncUsers
                name="service_user"
                onChangeSelect={(event: any) =>
                  formik.setFieldValue("service_user", event)
                }
                isMulti={false}
                placeholder={`${t("Select Service User")}...`}
                isShowIconCheck={false}
                isAllOption={true}
                listCheckedUsers={formik.values.service_user}
                keywordSearch={barID}
                defaultParams={{ is_active: 1 }}
              />
              {formik.touched.service_user && formik.errors.service_user ? (
                <div className="text-danger mt-2">
                  {formik.errors.service_user}
                </div>
              ) : null}
            </Col>

            <div className="col-lg-12">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
                <button
                  className="btn btn-secondary fs-14"
                  color="light"
                  type="button"
                  onClick={onCloseClick}
                  disabled={isLoading}
                  style={{ width: "100px" }}
                >
                  {t("Button Close")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
